@if (open()) {
<app-modal [title]="title() | translate: titleParams()"
  [closeButtonText]="cancelLabel() | translate: cancelLabelParams()"
  [confirmButtonText]="confirmLabel() | translate: confirmLabelParams()" [confirmButtonType]="actionButtonTone()"
  [confirmButtonIcon]="actionIcon()" [confirmDisabled]="confirmDisabled()" [showConfirmButton]="true"
  [closeDisabled]="busy()" width="min(100%, 40rem)" maxHeight="calc(100dvh - 2rem)"
  [attr.aria-busy]="busy()" (closed)="onCancelClick()" (confirmed)="onConfirmClick()">
  <div class="confirm-modal__content" [class.center]="modalIcon()">
    @if (modalIcon()) {
    <span class="confirm-modal__icon" [class.confirm-modal__icon--danger]="actionButtonTone() === 'danger'"
      aria-hidden="true">
      <app-icon [icon]="modalIcon()!" [width]="28" [height]="28" aria-hidden="true" [color]="actionButtonTone() === 'danger' ? 'var(--safegpt-accent)' : 'var(--safegpt-primary)'" />
    </span>
    }

    <p>{{ message() | translate: messageParams() }}</p>

    @if (requireConfirmation()) {
    <label class="confirm-modal__checkbox">
      <input type="checkbox" [checked]="confirmationChecked()" (change)="onConfirmationCheckedChange($event)" />
      <span>{{ confirmationLabel() | translate }}</span>
    </label>
    }
  </div>
</app-modal>
}

